import { Button, Select } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { classNames } from 'src/utilities';
import { getPractitionersByOrgs } from '../../../ambient_solo/store/actions/settings';
import { pushTemplateOverrides } from '../../../SuperAdmin/store/actions/templateoverrides.action';

const TemplatesAdminTarget = ({
  selectedTemplatesDataSource,
  onSuccessfulPush,
}) => {
  const dispatch = useDispatch();
  const [organizationDropdown, setOrganizationDropdown] = useState([]);
  const [practitionerDropdown, setPractitionerDropdown] = useState([]);
  const [selectedOrganizations, setSelectedOrganizations] = useState([]);
  const [selectedPractitioners, setSelectedPractitioners] = useState([]);
  const [practitionerPayload, setPractitionerPayload] = useState([]);

  const { currentPractitioner } = useSelector(
    (state) => state?.practitionerState
  );
  const { practitionersByOrgs, practitionersByOrgsLoading } = useSelector(
    (state) => state.settingsState
  );

  useEffect(() => {
    if (currentPractitioner?.org_uuid) {
      setOrganizationDropdown([
        {
          label: currentPractitioner?.org_name,
          value: currentPractitioner?.org_uuid,
        },
      ]);
      setSelectedOrganizations([currentPractitioner?.org_uuid]);
    }
  }, [currentPractitioner?.org_uuid]);

  useEffect(() => {
    if (selectedOrganizations.length > 0) {
      dispatch(getPractitionersByOrgs(selectedOrganizations));
    } else {
      setPractitionerDropdown([]);
    }
  }, [selectedOrganizations]);

  useEffect(() => {
    if (practitionersByOrgsLoading === false) {
      setPractitionerDropdown(
        practitionersByOrgs?.map((item) => ({
          label: item?.practitioner_name,
          value: item?.practitioner_id,
          org_uuid: item?.org_uuid,
        })) || []
      );
    }
  }, [practitionersByOrgs]);

  const handleAssignTemplates = () => {
    const practitionerMap = practitionerPayload.reduce((acc, item) => {
      if (!acc[item.org_uuid]) {
        acc[item.org_uuid] = [];
      }
      acc[item.org_uuid].push(item.practitioner_id);
      return acc;
    }, {});

    dispatch(
      pushTemplateOverrides(
        selectedTemplatesDataSource.map((item) => ({
          template_override_id: item.template_overrides_id,
          org_uuid: item.org_uuid,
        })),
        selectedOrganizations,
        practitionerMap,
        setSelectedOrganizations,
        setSelectedPractitioners,
        onSuccessfulPush,
        false
      )
    );
  };

  return (
    <div className="flex-1">
      <div className="flex flex-col gap-1">
        <div className="text-lg font-bold font-sans pl-1 mb-2">Target</div>
        <Select
          mode="multiple"
          showSearch={true}
          optionFilterProp="label"
          style={{ width: '100%' }}
          options={organizationDropdown}
          placeholder="Select account(s)"
          value={selectedOrganizations}
          onChange={(values) => {
            setSelectedOrganizations(values);
          }}
          className={classNames('font-sans w-full', 'single-select')}
        />
        <Select
          mode="multiple"
          showSearch={true}
          loading={practitionersByOrgsLoading}
          disabled={practitionersByOrgsLoading}
          optionFilterProp="label"
          style={{ width: '100%' }}
          options={practitionerDropdown}
          placeholder="Select practitioner(s)"
          value={selectedPractitioners}
          onChange={(values, option) => {
            setSelectedPractitioners(values);
            setPractitionerPayload(
              option.map((item) => ({
                practitioner_id: item.value,
                org_uuid: item.org_uuid,
              }))
            );
          }}
          className={classNames(
            'font-sans w-full custom-loading-select',
            'single-select'
          )}
        />
        <div className="flex justify-end mt-2">
          <Button
            type="primary"
            onClick={handleAssignTemplates}
            disabled={selectedOrganizations.length === 0}
            className={`disabled:text-white ${
              selectedOrganizations.length === 0 && 'opacity-50'
            }`}
          >
            Push templates
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TemplatesAdminTarget;
